import CommonSelect, { type SelectProps as CommonSelectProps } from 'common-ui/components/Select'
export type { RichOption, Option } from 'common-ui/components/Select'
import { validate } from '../../../utils'

interface SelectProps extends Omit<CommonSelectProps, 'rules'> {
  validators?: Parameters<typeof validate>[0]
}

/**
 * Simple select component using React Hook Form
 * @param props {
 *   name: field name
 *   label?: label to show
 *   validators?: validation rules for the field
 *   required?: adds validation
 *   options: array of string, numbers or complex objects with name, value, disabled state and tooltip
 *   defaultFirst?: If true, options[0] is set by default
 *   onChange?: callback function to handle selection changes
 * }
 */
const Select = ({ validators, required, ...props }: SelectProps) => {
  const mergedValidators = { ...validators }
  if (required) mergedValidators.presence = true
  const hasValidation = Object.keys(mergedValidators).length > 0
  // Always pass an explicit `validate` (undefined when there are no validators) so that re-registering
  // this field clears any stale rule inherited from a previous mount of the same field name. Without
  // this, react-hook-form (with shouldUnregister: false) merges register options over the existing
  // field and keeps the old `validate`, so an optional field can wrongly inherit a `required` rule
  // from a differently-configured Select that shared its name (EDGE-6606).
  const rules = { validate: hasValidation ? validate(mergedValidators) : undefined }
  return <CommonSelect {...props} required={required} rules={rules} />
}

export default Select
